<button
    {...$$restProps}
    class="btn-primary"
    on:click
>
    <slot/>
</button
>
